/**
 * Canonical deep-link for an admin notification subject (or workflow). Referrals
 * and medical-record requests live on separate admin routes; an inbound fax
 * (notification subjectType `INBOUND_FAX`, subjectId = fax id) opens the fax
 * viewer. Returns null for an unknown type or a missing id so callers can fall
 * back. Single source of truth for these route literals — used by the
 * notification center, the sent-fax list, and the admin referral/records-request
 * list.
 */
export function adminWorkflowHref(
  workflowType: string | null | undefined,
  workflowId: string | null | undefined
): string | null {
  if (!workflowId) return null;
  switch (workflowType) {
    case 'REFERRAL':
      return `/all-referrals/${workflowId}`;
    case 'MEDICAL_RECORD_REQUEST':
      return `/admin/records-requests/${workflowId}`;
    case 'INBOUND_FAX':
      return `/faxes/${workflowId}`;
    default:
      return null;
  }
}
